import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-membership-card",
  "use": "icon-membership-card-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-membership-card\"><path d=\"M3.2 3C1.987 3 1 4.01 1 5.25v13.5C1 19.99 1.987 21 3.2 21h17.6c1.213 0 2.2-1.01 2.2-2.25V5.25C23 4.01 22.013 3 20.8 3H3.2zm0 2.25h17.6l.002 13.5H3.2V5.25zm6 1.688L7.81 10.24l-3.51.347 2.615 2.349-.737 3.564L9.2 14.588l3.102 1.912-.898-3.566 2.694-2.347-3.51-.347L9.2 6.937zm5 7.312v2.25h2.2v-2.25h-2.2zm3.3 0v2.25h2.2v-2.25h-2.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol